/**
 *  users.js
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

import * as actionTypes from '../actions/actionTypes';

const initialState = {
    users: []
};

export const users = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_USERS:
            return {
                ...state,
                users: action.users
            };
        case actionTypes.CLEAR_USERS:
            return {
                ...state,
                users: []
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/users.js